{
    "yes": "yes",
    "no": "no",
    "header.simulation_list": "List of simulations",
    "header.node_list": "List of nodes",
    "header.settings": "User settings",
    "header.simulation_detail": "Simulation",
    "header.simulation_add": "Add simulation",
    "header.simulation_add_new": "Add new simulation",
    "header.simulation_graph": "Simulation Graph",
    "nav.menu_open": "Expand",
    "nav.menu_close": "Close",
    "nav.search": "Search",
    "nav.node_list": "Nodes",
    "nav.simulation_list": "Simulations",
    "nav.settings": "Settings",
    "nav.back": "Back",
    "sort.new": "New",
    "sort.alph": "Alphabetical",
    "sort.recent_visited": "Recently viewed",
    "sort.updated": "Recently updated",
    "button.add_simulation": "Add simulation",
    "button.upload_file_simulation": "Upload from file",
    "button.create_simulation": "Create",
    "button.create_simulation_confirm": "Finish",
    "button.hide_filters": "Cancel filters",
    "button.download_simulation": "Download",
    "button.show_simulation_graph": "Show graph",
    "button.next_page": "next page",
    "button.previous_page": "previous page",
    "button.show_more": "show more",
    "button.collapse": "hide",
    "button.list_compact_enable": "change to compact list",
    "button.list_compact_disable": "change to detailed list",
    "label.name": "Name",
    "label.date": "Date",
    "label.type": "Type",
    "label.status": "Status",
    "label.dimensionality": "Dimensionality",
    "label.simulation_type": "Type of simulation",
    "label.iteration_count": "Number of iterations",
    "label.time_delta": "Time step",
    "label.solar_wind_speed": "Wind speed",
    "label.dif_coef": "Diffusion coefficient",
    "label.kparkper": "Kpar/Kper",
    "label.mu_width_cos": "Cosinus of Mu width",
    "label.language": "Language",
    "label.duration": "Duration",
    "label.progress": "Progress",
    "status.done": "Finished",
    "status.pending": "Pending",
    "status.in_progress": "In progress",
    "status.canceled": "Canceled",
    "status.uploaded": "Uploaded",
    "date.days_short": "d",
    "date.hours_short": "h",
    "date.minutes_short": "m",
    "date.seconds_short": "s",
    "page.simulation_list.empty": "No simulations",
    "page.simulation_details.empty": "Simulation couldn't be found",
    "page.node_list.unknown": "Unknown",
    "page.node_list.empty": "No nodes",
    "page.node_list.is_active": "Active",
    "page.node_list.is_computing": "Computing",
    "page.node_list.last_update_time": "Last update",
    "page.simulation_new.upload_fail": "Sorry, we were unable to load the file.",
    "page.simulation_detail.unfinished_warning": "Simulation is not yet finished. Complete data will be available after it finishes.",
    "page.simulation_graph.not_landscape": "Rotate your device screen for easier graph viewing",
    "page.simulation_graph.api.download_error": "Sorry, we were unable to retrieve graph data.",
    "page.simulation_graph.unavailable": "Graph couldn't be loaded",
    "page.not_found.title": "We are sorry!",
    "page.not_found.description": "This page couldn't be found...",
    "notification.on_online": "Back online.",
    "notification.on_offline": "Lost network connection.",
    "api.error.offline": "Please check your network connection and try again.",
    "api.error.unsuccessful_request": "Sorry, we were unable to connect to our servers. Please try again later.",
    "api.error.invalid_request": "Sorry, we were unable to retrieve the requested data. Please contact the administrator.",
    "api.error.invalid_response": "Sorry, we were unable to retrieve the requested data. Please try again later.",
    "api.error.invalid_response_partial": "Sorry, we were unable to retrieve some of the requested data. Please try again later.",
    "api.error.send.invalid_response": "Sorry, we were unable to send your request. Please try again later."
}